import { SSOBaseURL } from "@/constants";
import { useEffect, useRef } from "react";

const Login = () => {
  const redirected = useRef(false);

  useEffect(() => {
    if (!redirected.current && SSOBaseURL) {
      redirected.current = true;
      try {
        const parsed = new URL(SSOBaseURL);
        if (parsed.protocol !== "https:") {
          throw new Error("SSO Base URL must use HTTPS");
        }
        // Reconstruct URL from individually validated parsed components to
        // satisfy static-analysis taint rules. SSOBaseURL is a build-time
        // env var (VITE_SSO_BASE_URL), never sourced from user input.
        const safeUrl =
          parsed.origin + parsed.pathname + parsed.search + parsed.hash;
        window.location.assign(safeUrl);
      } catch {
        console.error("Invalid or unsafe SSO Base URL");
      }
    }
  }, []);

  return null;
};

export default Login;
